<div class="fc-horizontal-bar-chart">
  <ng-container *ngIf="!isLoading && chartData.length && results && results.length">
    <!-- CHART COLUMN -->
    <div *ngFor="let data of chartData; let i = index" class="fc-horizontal-bar-chart__item">
      <span class="fc-horizontal-bar-chart__item-name" title="{{ data.name }}">
        {{ data.name }}
      </span>

      <div
        class="fc-horizontal-bar-chart__item-bar"
        matTooltip="{{ data.name }}
        {{ data.value }}"
        matTooltipPosition="above"
        (click)="select.next(data)"
      >
        <div
          [ngStyle]="{ 'background-color': colors[i % colors.length], width: data.percentage + '%' }"
          class="fc-horizontal-bar-chart__bar-value"
        ></div>
        <div class="fc-horizontal-bar-chart__bar-background"></div>
      </div>

      <span class="fc-horizontal-bar-chart__item-value">{{ data.value }}</span>
    </div>
    <!--/ CHART COLUMN -->
  </ng-container>

  <!-- LOADING SKELETON -->
  <div class="fc-horizontal-bar-chart__skeleton" *ngIf="isLoading">
    <ngx-skeleton-loader count="10"></ngx-skeleton-loader>
  </div>
  <!--/ LOADING SKELETON -->

  <!-- NO DATA -->
  <div class="fc-horizontal-bar-chart__empty" *ngIf="!isLoading && (!chartData.length || !results || !results.length)">
    <p>{{ 'FC_HORIZONTAL_BAR.NO_DATA' | translate }}</p>
  </div>
  <!--/ NO DATA -->
</div>
